import React from 'react';
import styles from './styles/segmentation-step.module.scss';
import Form from '../../common/form/Form';
import { SCOPES } from '../../../constants/scopes.constants';
import ServiceAccessCard from './userEligibilityForm/ServiceAccessCard';

function UserEligibilityForm({
    values = {},
    onChange = {},
    onCancel,
    onSubmit,
    loading,
    disabledSave,
    confirmBeforeSubmit = false,
    submitText = 'Save',
    readOnly = false,
}) {
    return (
        <Form
            onSubmit={onSubmit}
            loading={loading}
            disabled={disabledSave}
            onCancel={onCancel}
            confirmBeforeSubmit={confirmBeforeSubmit}
            submitText={loading ? 'Saving...' : submitText}
            readOnly={readOnly}
            submitGuardScope={SCOPES.CONFIGURATIONS_MANAGE}
            hideActions
        >
            <div className={styles.formStack}>
                <ServiceAccessCard
                    values={values}
                    handlers={onChange}
                    readOnly={readOnly}
                />
            </div>
        </Form>
    );
}

export default UserEligibilityForm;
